import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { Route } from "@route-types/Podcasts/PodcastsPage/+types/PodcastsPage";
import { fetchPodcastsPageData } from "@routes/Podcasts/PodcastsPage/PodcastsPage.server";
import PodcastsPageContent from "@routes/Podcasts/PodcastsPage/PodcastsPageContent";
import { PodcastPageContext } from "@routes/Podcasts/PodcastsPage/utils/types";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

/** This is the main entry point component for /podcasts route. */
const PodcastsPage = (): React.ReactElement => {
  const context = useLoaderData<PodcastPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return <PodcastsPageContent {...context.payload.data} />;
};

export default PodcastsPage;

export const loader = async () => {
  return await fetchPodcastsPageData();
};

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as PodcastPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};
